import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Platform, PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { POIDto } from 'src/app/api/exa';
import { BaseDataComponent } from 'src/app/core/components/base-data.component';
import { EnumHelper } from 'src/app/enums/enum-helper';
import { MarkerTypeEnum } from 'src/app/enums/marker-type-enum';
import { LogService } from 'src/app/services/log.service';

export class SelectOption {
  label!: string;
  value: any;
  baseItem?: any;
}

@Component({
  selector: 'app-poi-edit',
  templateUrl: './poi-edit.component.html',
  styleUrls: ['./poi-edit.component.scss'],
})
export class PoiEditComponent extends BaseDataComponent  implements OnInit {

  isIOS: boolean;
  types: SelectOption[] = [];
  type: string;
  comment: string;
  item: POIDto | undefined;




  constructor(
    private platform: Platform,
    private popoverController: PopoverController,
     private _logService: LogService,
    private _translateService: TranslateService,
    private _changeDetectorRef: ChangeDetectorRef,
  ) {
    super(
      'PoiEditComponent',
      _logService, _translateService, _changeDetectorRef,
    );
     if (this.platform.is('ios')) {
      this.isIOS = true;
    } else {
     this.isIOS = false;
    }
   }

  ngOnInit() {
    this.types = this.typeOptions();

  }

   private typeOptions(): SelectOption[] {
    const options: SelectOption[] = [];
    for (const enumValue of EnumHelper.values(MarkerTypeEnum, [MarkerTypeEnum.BORDER])) {
      options.push({ label: this.getTranslation('MARKER.' + enumValue), value: enumValue });
    }
    return options;
  }

  close() {
    this.popoverController.dismiss();
  }

  onOkClick() {    
     let create = false;
    if (!this.item) {
      // create empty field item
      create = true;
      this.item = {};
    }

    // fill in data from form
    this.item.type = this.type;
    this.item.comment = this.comment;
    console.log("POI to be returned: ", this.item);
    

    this.popoverController.dismiss(this.item);
  }

}
